<br />
<div class="container container-shadow d-flex">
  <fieldset class="font-color-navy">
    <legend>Summary of your request</legend>
    <div>
      <label>Title:</label>
      {{title}}
    </div>
    <div>
      <label>Deadline:</label>
      {{deadline}}
    </div>
    <div>
      An email is sent to each reviewer.      
    </div>

    <div>A consolidated email will be sent to you every day on 8AM CET with current status of all open reviews sessions created by you.</div>
    <hr />   

    <div class="ml-8 pull-right">
      <a class="btn-new-ui" routerLink="/requests">Go to My Requests</a>&nbsp;&nbsp;
      <a class="btn-new-ui pl-1" routerLink="/">Go to Home</a>
    </div>
  </fieldset>
</div>
